<template>
  <form-group class="textarea-input"
              :label="label"
              :errors="internalErrors"
              @focus="focus">
    <textarea ref="primaryInput"
              class="uk-textarea"
              :class="textareaCss"
              :value="internalValue"
              :placeholder="placeholder"
              :disabled="disabled"
              :rows="calculatedRows"
              @input="onChangeText"
              @focus="$emit('focus')"
              @blur="$emit('blur')"></textarea>
  </form-group>
</template>

<script>
import Input from '@/mixins/Input';

export default {
  name: 'textarea-input',
  mixins: [Input],
  props: {
    value: String,
    placeholder: String,
    rows: [Number, String],
    resize: {
      type: Boolean,
      default: true,
    },
    collapse: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    textareaCss() {
      return {
        ...this.inputCss,
        'textarea-input__field': true,
        'textarea-input__field--resizable': this.resize,
      };
    },
  },
  data() {
    return {
      baseLineHeight: null,
      calculatedRows: this.rows || 1,
    };
  },
  mounted() {
    this.maybeCalculateRows();
  },
  methods: {
    maybeCalculateRows() {
      if (!this.collapse) return;
      const input = this.$refs.primaryInput;
      const lineHeight = parseInt(
        window.getComputedStyle(input).getPropertyValue('line-height'), 10,
      );
      let rows = Math.ceil((input.scrollHeight / lineHeight) - 1);
      if (rows < 1) rows = 1;
      this.calculatedRows = rows;
    },
    onChangeText(event) {
      this.maybeCalculateRows();
      this.onInput(event);
    },
  },
};
</script>

<style scoped lang="scss">
.textarea-input__field {
  padding: {
    top: 8px;
    bottom: 8px;
  }
}
.textarea-input__field--resizable {
  resize: vertical;
  min-height: 40px;
}
</style>



// WEBPACK FOOTER //
// TextareaInput.vue?4041c1c4